import React from 'react';
import SectionHeader from './ui/SectionHeader';

const REALITIES = [
  {
    title: 'Privacy anxiety is real',
    body: 'A screenshot. A leaked chat. Someone you know on the same app. For many queer people, being online has never felt fully safe — especially when you’re dating or hooking up.',
  },
  {
    title: 'Trust got traded for visibility',
    body: 'Other apps push you to show more — more photos, more location, more proof you’re “real.” But not everyone can be publicly out. That shouldn’t mean less protection.',
  },
  {
    title: 'Connection shouldn’t cost exposure',
    body: 'You still deserve to meet people, date, chat, and explore — without feeling like the app is working against you.',
  },
];

function WhyStrapInExists() {
  return (
    <section className="relative overflow-hidden bg-onyx py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_100%_0%,rgba(216,27,96,0.06),transparent)]" aria-hidden />

      <div className="site-container relative">
        <SectionHeader
          tag="Why we built this"
          title="Why this"
          titleAccent="needed to exist"
          description="Most apps were built for dating and hookups. They weren’t built for queer realities — and that gap matters."
        />

        <div className="grid gap-4 md:grid-cols-3">
          {REALITIES.map((item) => (
            <article key={item.title} className="glass-card-hover p-6 md:p-7">
              <h3 className="mb-3 text-lg font-bold text-white">{item.title}</h3>
              <p className="text-sm leading-relaxed text-silver">{item.body}</p>
            </article>
          ))}
        </div>

        <p className="mx-auto mt-12 max-w-3xl text-center text-base leading-relaxed text-mist md:text-lg">
          StrapIn exists because{' '}
          <strong className="text-white">queer safety is different</strong> — closeted users, outing risk,
          scams, fake profiles, and the quiet fear of being too visible. Connection should not cost your
          privacy.
        </p>
      </div>
    </section>
  );
}

export default WhyStrapInExists;
